import { delegate } from '@d3r/js-tools';

export default function bindTriggers() {
    delegate(
        document,
        'click',
        'a[lp],button[lp],[lp-trigger^="click"]',
        async e => {
            e.preventDefault();
            const triggerElement = await getTriggerElement(e.closest);
            triggerElement.fire();
        }
    );

    delegate(document, 'submit', 'form[lp]', async e => {
        e.preventDefault();
        const triggerElement = await getTriggerElement(e.closest);
        const formData = new FormData(e.closest);

        // FormData does not include the value from the submit button by default
        if (e.submitter) {
            formData.append(e.submitter.name, e.submitter.value);
        }

        triggerElement.formData = formData;
        triggerElement.fire();
    });

    delegate(
        document,
        'change',
        'form[lp-trigger="change"] input, form[lp-trigger="change"] select, form[lp-trigger="change"] textarea',
        async e => {
            e.preventDefault();
            const form = e.closest.closest('form[lp-trigger="change"]');
            const triggerElement = await getTriggerElement(form);
            const formData = new FormData(form);

            triggerElement.formData = formData;
            triggerElement.fire();
        }
    );

    delegate(
        document,
        'change',
        'input[lp-trigger^="change"], select[lp-trigger^="change"]',
        async e => {
            const triggerElement = await getTriggerElement(e.closest);
            const formData = new FormData();
            formData.append(e.closest.name, e.closest.value);

            triggerElement.formData = formData;
            triggerElement.fire();
        }
    );

    delegate(document, 'input', 'input[lp-trigger^="input"]', async e => {
        if (
            e.closest.hasAttribute('lp-prefix-length') &&
            e.closest.value.length <
                parseInt(e.closest.getAttribute('lp-prefix-length'))
        ) {
            if (e.closest.hasAttribute('lp-prefix-clear')) {
                const triggerElement = await getTriggerElement(e.closest);
                await triggerElement.clear();
            }
            return;
        }

        const triggerElement = await getTriggerElement(e.closest);
        const formData = new FormData();
        formData.append(e.closest.name, e.closest.value);

        triggerElement.formData = formData;
        triggerElement.fire();
    });

    window.addEventListener('popstate', e => {
        if (e.state && e.state.live_page) {
            console.warn(
                'Live Page popstate handling has not been fully implemented yet.'
            );
        }
    });
}

async function getTriggerElement() {
    const { default: TriggerElement } = await import('../elements/trigger');
    return TriggerElement.get(...arguments);
}

if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
        import('../elements/trigger');
    });
}
